import { render, staticRenderFns } from "./FormulateFullPhoneNumber.vue?vue&type=template&id=0e03dfcf&scoped=true"
import script from "./FormulateFullPhoneNumber.vue?vue&type=script&lang=js"
export * from "./FormulateFullPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e03dfcf",
  null
  
)

export default component.exports